export default __webpack_public_path__ + "static/twitter-193f298133f486a0aede35f5b5a9344d.png";